module.exports = __webpack_public_path__ + "img/ptrc-cell-line.cbdf3de4.png";